import { render, staticRenderFns } from "./Solicitudtransferencia.vue?vue&type=template&id=18b38e81&scoped=true"
import script from "./Solicitudtransferencia.vue?vue&type=script&lang=js"
export * from "./Solicitudtransferencia.vue?vue&type=script&lang=js"
import style0 from "./Solicitudtransferencia.vue?vue&type=style&index=0&id=18b38e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b38e81",
  null
  
)

export default component.exports